import { render, staticRenderFns } from "./SafetyPlanRecordsTable.vue.html?vue&type=template&id=50866828&scoped=true&external"
import script from "./SafetyPlanRecordsTable.vue.js?vue&type=script&lang=js&external"
export * from "./SafetyPlanRecordsTable.vue.js?vue&type=script&lang=js&external"
import style0 from "./SafetyPlanRecordsTable.vue.scss?vue&type=style&index=0&id=50866828&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50866828",
  null
  
)

export default component.exports